import {validationRules} from 'components/forms/validationRules.js';
import {isFunction, isNoU} from "./DBUtils";

/**
 * Creates a function that loops through validation rules defined in the form config for each field
 * Put together an map of failed validations and return it
 *
 * Note: this validator only doesn't support subsection/subresource validation
 *
 * @param config
 * @return {{}} - Failed validation rules by field name
 */
export const makeFormValidator = (config) => {
    // If no config, return validator that always returns no failed validations
    if (isNoU(config)) {
        return () => ({});
    }

    return (resource) => {
        let failedValidationsByField = {};
        for (let fieldConfig of config.fields) {
            if (fieldConfig.type === 'hidden') {
                continue;
            }
            let fieldName = fieldConfig.name;

            let rules = [];
            if (!isNoU(fieldConfig.props) && !isNoU(fieldConfig.props.validationRules)) {
                rules = fieldConfig.props.validationRules.slice();
            }
            let value = resource[fieldName];
            let failedValidations = [];

            // Mocking the current resource to allow for functional 'required' checks
            let fieldRequired = (isFunction(fieldConfig.required) ? fieldConfig.required({currentResource: resource}) : fieldConfig.required === true);

            // Inject not null or blank rule if required
            if (fieldRequired) {
                rules.push({
                    type: "NotNullOrBlank"
                });
            }

            for (let rule of rules) {
                let validationRule = validationRules[rule.type];

                // If validation for value fails, add it to list
                if (!validationRule(value, rule.params)) {
                    failedValidations.push(rule);
                }
            }

            if (failedValidations.length > 0) {
                failedValidationsByField[fieldName] = failedValidations;
            }
        }
        return failedValidationsByField;
    }
};


// WEBPACK FOOTER //
// ./public/utils/forms.js